<template>
  <div class="payment-details">
    <div class="container-fluid">
      <p class="payment-packages__alert" v-html="$t('change_of_details')"></p>
    </div>

    <div class="container-fluid">
      <h4>
        <b>{{ $t('details') }}</b>
      </h4>
    </div>

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-7">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>{{ $t('beneficiarys_bank') }}</th>
                <th>{{ $t('privatbank') }}</th>
                <th>{{ $t('raiffeisen') }}</th>
              </tr>
            </thead>
            <tbody>
              <!-- <tr>
                <td>{{ $t('mfo') }}</td>
                <td>380775</td>
                <td>380805</td>
              </tr>-->
              <tr>
                <td>IBAN</td>
                <td>UA19 305299 00000 26002006700651</td>
                <td>UA96 380805 00000 00026001641198</td>
              </tr>
              <tr>
                <td>{{ $t('recipient') }}</td>
                <td colspan="2" style="text-transform: uppercase;">{{ $t('cde_source') }}</td>
              </tr>
              <tr>
                <td>{{ $t('edrpou') }}</td>
                <td colspan="2">40345655</td>
              </tr>
              <tr>
                <td>{{ $t('purpose_payment') }}</td>
                <td colspan="2">
                  <span
                    v-t="{
                    path: 'payer_payment',
                    args: {
                      last_name: lastName,
                      first_name: firstName,
                      patronymic: patronymic,
                    },
                  }"
                  ></span>
                  <em>({{ $t('set_class_package') }})</em>
                </td>
              </tr>
            </tbody>
          </table>
          <div style="margin-top: 20px;">
	<a href="https://cdo.org.ua/pdf/Оферта%20(Джерело).pdf" title="Договір Оферти Джерело">
		<img src="/static/front-end/public/assets/images/doc-icon--gray.svg" target="_blank" alt="" width="22px" class="aside-menu__icon">
		<span data-v-102b8074="" class="title">Договір Оферти Джерело</span>
	</a>
</div>
        </div>

        <div class="col-md-5">
          <div class="video">
            <iframe
              src="https://www.youtube.com/embed/gqbaiXbBwFU"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    student: {
      type: Object,
      default: null,
    },
  },
  computed: {
    lastName() {
      return this.student && this.student.last_name || 'Іваненко';
    },
    firstName() {
      return this.student && this.student.first_name || 'Іван';
    },
    patronymic() {
      return this.student && this.student.patronymic || 'Іванович';
    },
  },
}
</script>

<style lang="scss" scoped>
  .table > thead > tr > th {
    vertical-align: top;
  }
</style>
